import { createSelector } from "reselect";

const getCnvAnnotation = createSelector(
  (state) => state.variantResult,
  (variantResult) =>
    variantResult && variantResult.sv_acmg_annotation
      ? variantResult.sv_acmg_annotation
      : undefined
);
const getCnvClassifications = createSelector(getCnvAnnotation, (v) =>
  v && v.classifications ? v.classifications : undefined
);

const getCnvVerdict = createSelector(getCnvAnnotation, (v) =>
  v && v.verdict ? v.verdict : undefined
);

const getCnvVersion = createSelector(getCnvAnnotation, (v) =>
  v && v.version_name ? v.version_name : undefined
);

const getCnvSampleFindings = createSelector(getCnvAnnotation, (v) =>
  v && v.sample_findings ? v.sample_findings : undefined
);

const getVariantInfo = createSelector(getCnvAnnotation, (v) => ({
  ...(v && v.chromo && { chromo: v.chromo }),
  ...(v && v.gene_symbol && { geneSymbol: v.gene_symbol }),
  ...(v && v.type && { type: v.type }),
  ...(v && v.pos && { pos: v.pos }),
  ...(v && v.end && { end: v.end }),
  ...(v && v.length && { length: v.length }),
}));

export {
  getCnvAnnotation,
  getCnvClassifications,
  getCnvVerdict,
  getCnvVersion,
  getCnvSampleFindings,
  getVariantInfo,
};
